import {
  Radio as AntdRadio,
  type RadioChangeEvent as AntdRadioChangeEvent,
  type RadioGroupProps as AntdRadioGroupProps,
  type CheckboxOptionType,
} from 'antd'
import { Col } from '../Col'
import { Row } from '../Row'
import { Space, type SpaceProps } from '../Space'
import styles from './styles.module.scss'
export { Radio } from 'antd'

export type RadioChangeEvent = AntdRadioChangeEvent

export type RadioOption = CheckboxOptionType

export interface RadioGroupProps extends Omit<AntdRadioGroupProps, 'options'> {
  options: RadioOption[]
  direction?: 'horizontal' | 'vertical'
  colSpan?: number
  spaceClassName?: string
  spaceSize?: SpaceProps['size']
  rounded?: boolean
}

export function RadioGroup({
  options,
  direction,
  colSpan,
  spaceClassName,
  spaceSize,
  rounded,
  optionType,
  ...props
}: RadioGroupProps) {
  const radioClassname = optionType === 'button' && rounded ? styles.rounded : undefined

  return (
    <AntdRadio.Group optionType={optionType} {...props}>
      {colSpan ? (
        <Row gutter={[0, 8]}>
          {options.map(({ label, value, ...rest }) => (
            <Col key={value?.toString()} span={colSpan}>
              <AntdRadio className={radioClassname} value={value} {...rest}>
                {label}
              </AntdRadio>
            </Col>
          ))}
        </Row>
      ) : (
        <Space className={spaceClassName} direction={direction} size={spaceSize}>
          {options.map(({ label, value, ...rest }) => (
            <AntdRadio className={radioClassname} key={value?.toString()} value={value} {...rest}>
              {label}
            </AntdRadio>
          ))}
        </Space>
      )}
    </AntdRadio.Group>
  )
}
